import {Injectable} from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {AuthService, LoginResponse} from './auth.service';
import {UserPreview} from '../interfaces/user-preview.interface';
import {CycleService} from './cycle.service';
import {LocalStorageService} from './local-storage.service';
import {SharedService} from './shared.service';
import {catchError, tap} from 'rxjs/operators';
import {ActivatedRoute, Router} from "@angular/router";

@Injectable()
export class ImpersonateInterceptor implements HttpInterceptor {

    private _requestsCount: number = 0;

    constructor(
        private _authService: AuthService,
        private _sharedService: SharedService,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _cycleService: CycleService,
    ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        this._sharedService.setLoaderValue(true);
        this._requestsCount++;

        let processId = localStorage.getItem('ProcessId');
        if (processId !== null) {
            request = request.clone({
                setHeaders: {
                    'ProcessId': processId
                }
            });
        }
        let cycleId = this._cycleService.getCycle();
        if (cycleId !== null) {
            request = request.clone({
                setHeaders: {
                    'CycleId': cycleId
                }
            });
        }

        const titleRoute = this.getTitleFromRoute(this._router.routerState, this._router.routerState.root);
        if (titleRoute.length > 0) {
            request = request.clone({
                setHeaders: {
                    'TitlePage': titleRoute[0]
                }
            });
        }


        const impersonatedUser: UserPreview | null = this._authService.getImpersonatedUser();
        if (impersonatedUser && impersonatedUser.userId) {
            request = request.clone({
                setHeaders: {
                    'UserIdToImpersonate': impersonatedUser.userId,
                }
            });
        }

        return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse || event instanceof HttpErrorResponse) {
                this._requestsCount--;
                if (this._requestsCount === 0)
                    this._sharedService.setLoaderValue(false);
            }
            return event;
        }))
            .pipe(catchError((error, caught) => {
                // intercept the respons error and displace it to the console
                this._requestsCount--;
                this._sharedService.setLoaderValue(false);
                console.log(error);
                if (!this.handleAuthError(error)) {
                    return of(error.message);
                }
                throw error;
            }) as any);
    }

    private getTitleFromRoute(state: any, parent: any): string[] {
        const data: string[] = [];
        if (parent && parent.snapshot.data && parent.snapshot.data.title) {
            data.push(parent.snapshot.data.title);
        }
        if (state && parent && parent.firstChild) {
            data.push(...this.getTitleFromRoute(state, parent.firstChild));
        }

        return data;
    }

    private handleAuthError(err: HttpErrorResponse): boolean {
        // handle your auth error or rethrow
        if (err.status === 401) {
            // navigate /delete cookies or whatever
            console.log('handled error ' + err.status);
            this._authService.logout();
            // if you've caught / handled the error, you don't want to
            // rethrow it unless you also want downstream consumers to have to handle it as well.
            return false;
        }
        return true;
    }
}
